/* src/app/pages/shop/purchases/edit-rent/edit-rent.component.scss */
/*# sourceMappingURL=edit-rent.component.css.map */
